import i18n from 'i18next';
import { initReactI18next } from 'react-i18next'

const languages = ['en', 'zh-CN', 'zh-HK'];
var langs =  localStorage.getItem("lang")
const lang = languages.includes(langs) ? langs : 'zh-CN';

i18n.use(initReactI18next).init({
    fallbackLng: lang,
    lng: lang,
    resources: {
        en: {
            translations: require('./locales/en/en.json')
        },
        "zh-CN": {
            translations: require('./locales/zh-CN/zh-CN.json')
        },
        "zh-HK": {
            translations: require('./locales/zh-HK/zh-HK.json')
        }
    },
    ns: ['translations'],
    defaultNS: 'translations'
});

i18n.languages = languages;

export default i18n;